//
// SymbolChar.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./SymbolTransformable";
import "./styles/TextAttributes";

var SymbolChar = createModule("gtl::SymbolChar", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::SymbolTransformable"], EventDispatcher, [
    ,
    {
        character: 7,
        textAttributes: 1,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default SymbolChar;
